import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandler, HttpUtility } from '@core/http';
import { UserProvider, UserTenants } from '@core/model';
import { ShellService } from '@mynexus/mfe-core';
import { ODataResponse, ProductNames } from '@mynexus/mynexus-ui-lib';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UserService {
  private apiBaseUrl: string;
  private apiBaseHHUrl: string;

  public handleError: HandleError;
  
  constructor(
    private httpUtility: HttpUtility, 
    private httpErrorHandler: HttpErrorHandler,
    shellService : ShellService
  ) {
    this.handleError = this.httpErrorHandler.createHandleError('UserService');
    this.apiBaseUrl = shellService.getBaseUrlFor(ProductNames.SDoH);
    this.apiBaseHHUrl = shellService.getBaseUrlFor(ProductNames.HomeHealth);
  }

  getUserProviders(query: string = ''): Observable<ODataResponse<UserProvider>> {
    return this.httpUtility.get<ODataResponse<UserProvider>>(
      `${this.apiBaseUrl}/UserProviders${query}`
    )
    .pipe(
      catchError(this.handleError('getUserProviders', {} as ODataResponse<UserProvider>))
    );
  }

  getUserTenants(): Observable<UserTenants> {
    const url = `${this.apiBaseHHUrl}/User/GetUserAndTenantsForRegistration`;
    return this.httpUtility
      .get<UserTenants>(url)
      .pipe(catchError(this.handleError('getTenants', {})));

  }}
